import axios from "axios";
import { format, addDays as addD, parseISO } from "date-fns";
import { id as idLocale, enGB } from "date-fns/locale";
import { useSearchParams } from "react-router-dom";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API });
http.interceptors.request.use((c) => {
  const t = localStorage.getItem("member_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  const s = localStorage.getItem("staff_token");
  if (s) c.headers["X-Staff-Token"] = s;
  return c;
});
http.interceptors.response.use((r) => r, (e) => {
  if (e?.response?.status === 401 && e.config?.url?.startsWith("/extranet") && !window.location.pathname.startsWith("/extranet/login")) {
    localStorage.removeItem("staff_token");
    window.location.href = "/extranet/login";
  }
  return Promise.reject(e);
});

export const imgUrl = (src, size = "md") =>
  src?.startsWith("/api/files/") ? `${process.env.REACT_APP_BACKEND_URL}${src}/${size}` : src;
export const imgSet = (src) =>
  src?.startsWith("/api/files/") ? `${imgUrl(src, "sm")} 420w, ${imgUrl(src, "md")} 900w, ${imgUrl(src, "lg")} 1600w` : undefined;

export const getDevice = () =>
  window.matchMedia("(max-width: 767px)").matches || /Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop";
export const ctxParams = (country, promo = "") => ({ device: getDevice(), country, promo_code: promo });

export const COUNTRIES = [["ID", "Indonesia"], ["SG", "Singapura"], ["MY", "Malaysia"], ["AU", "Australia"], ["JP", "Jepang"],
  ["KR", "Korea Selatan"], ["CN", "Tiongkok"], ["IN", "India"], ["US", "Amerika Serikat"], ["GB", "Inggris"], ["NL", "Belanda"], ["DE", "Jerman"]];

export const idr = (n) => "Rp " + Math.round(n || 0).toLocaleString("id-ID");

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "Data tidak valid: " + d.map((x) => x.loc?.slice(-1)[0]).join(", ");
  return "Terjadi kesalahan, coba lagi";
};

export const toISO = (d) => format(d, "yyyy-MM-dd");
export const todayISO = () => toISO(new Date());
export const addDays = (iso, n) => toISO(addD(parseISO(iso), n));
export const fmtDate = (iso, pattern = "EEE, d MMM yyyy") =>
  iso ? format(parseISO(iso), pattern, { locale: localStorage.getItem("ex_lang") === "en" ? enGB : idLocale }) : "-";

export const ratingText = (r) =>
  r >= 9 ? "Luar Biasa" : r >= 8.5 ? "Istimewa" : r >= 8 ? "Sangat Baik" : r >= 7 ? "Baik" : "Menyenangkan";

export const STATUS_LABEL = {
  pending: "Menunggu", confirmed: "Dikonfirmasi", cancelled: "Dibatalkan", no_show: "Tidak hadir",
};
export const PAY_LABEL = {
  unpaid: "Belum dibayar", pending: "Menunggu pembayaran", paid: "Lunas", failed: "Gagal",
  expired: "Kedaluwarsa", paid_at_channel: "Dibayar di channel", pay_at_hotel: "Bayar di hotel",
};
export const PROMO_KIND = {
  basic_deal: "Basic Deal", last_minute: "Last Minute", early_bird: "Early Bird", mobile: "Mobile", geo: "Geo / Negara",
  member: "Member", promo_code: "Kode Promo", campaign: "Campaign", flash_sale: "Flash Sale",
};

export function useStay() {
  const [sp] = useSearchParams();
  const ci = sp.get("check_in") || addDays(todayISO(), 1);
  return {
    city: sp.get("city") || "",
    check_in: ci,
    check_out: sp.get("check_out") || addDays(ci, 2),
    guests: Number(sp.get("guests") || 2),
    rooms: Number(sp.get("rooms") || 1),
  };
}

export const stayQuery = (s) =>
  new URLSearchParams({
    check_in: s.check_in, check_out: s.check_out, guests: s.guests, rooms: s.rooms, ...(s.city ? { city: s.city } : {}),
  }).toString();
